import { Directive, TemplateRef, OnInit, OnDestroy } from "@angular/core";

import type { IHeaderFooterTemplate } from "../types";

import { LgPivotTableComponent } from "../lg-pivot-table.component";

@Directive({
    standalone: true,
    selector: "[lgPivotTableFooterDef]"
})
export class LgPivotTableFooterDefDirective
    implements IHeaderFooterTemplate<any>, OnInit, OnDestroy
{
    public constructor(private _table: LgPivotTableComponent, private _template: TemplateRef<any>) {
        // empty
    }

    public get template(): TemplateRef<any> {
        return this._template;
    }

    public ngOnInit(): void {
        this._table.addFooterTemplate(this);
    }

    public ngOnDestroy(): void {
        this._table.removeFooterTemplate(this);
    }
}
